module.exports = __webpack_public_path__ + "static/media/reader_opened.43ef80d0.ico";